import store from './store';
import container from './components/Container';

export { store };

export default container;